import { PopoverIcon } from './PopoverIcon';

// TODO: in v9, move styled() from PopoverIcon.jsx to here
export var StyledPopoverIcon = PopoverIcon;